import { ReactNode } from 'react';
import { Dropdown } from '@Components/Dropdown';
import { Size } from '@Components/designConstants';
import { FilterSection } from './FilterSection';

interface DropdownFilterSectionProps<T extends string> {
  label: string;
  options: { label: string; value: T }[];
  selected: T[];
  onChange: (next: T[]) => void;
}

export const DropdownFilterSection = <T extends string>({
  label,
  options,
  selected,
  onChange
}: DropdownFilterSectionProps<T>): ReactNode => (
  <FilterSection label={label}>
    <Dropdown<T>
      size={Size.LG}
      searchable
      multiSelect
      options={options}
      value={selected}
      placeholder={`All ${label}`}
      clearable
      onClear={() => onChange([])}
      onChange={onChange}
      fitMenuToContent
      // The filter panel scrolls on the y-axis, which forces overflow-x to clip too; portal the
      // menu out so a menu wider than the panel isn't cut off.
      menuPortalTarget={document.body}
    />
  </FilterSection>
);
